import { childrenReturnsIntakePageBreadcrumbs } from '../../config';
import { useReturnsScanner, useScannerFocus } from '../../hooks';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useNavigate } from 'react-router-dom';
import { useRef, useMemo } from 'react';
import {
  ScannedItemsList,
  ScannerActions,
  ScannerPanel,
  ConfirmDriverModal,
} from '../../components';

const ReturnsIntakeScanner = () => {
  const navigate = useNavigate();
  const inputRef = useRef<HTMLInputElement>(null);

  const {
    driver,
    setDriver,
    setDriverSearch,
    driverOptions,
    isDriversLoading,
    scannedShippings,
    failedReasons,
    inputValue,
    setInputValue,
    isScannerActive,
    setIsScannerActive,
    isProcessing,
    handleScan,
    handleRemove,
    handleReturn,
    pendingDriver,
    confirmDriver,
    cancelDriver,
  } = useReturnsScanner();

  useScannerFocus(inputRef, isScannerActive);

  const breadcrumbs = useMemo(
    () => childrenReturnsIntakePageBreadcrumbs(navigate),
    [navigate]
  );

  const onScan = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleScan(inputValue);
      setInputValue('');

      const input = inputRef.current;
      if (input) {
        input.value = '';
        input.blur();
        setTimeout(() => input.focus(), 0);
      }
    }
  };

  const handleConfirmDriver = async () => {
    await confirmDriver();
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks
        actualPage='Escaneo de Devoluciones'
        breadcrumbs={breadcrumbs}
      />

      <section className='w-full h-full flex flex-col items-start'>
        <div className='w-full flex flex-col gap-8'>
          <ScannerPanel
            driver={driver}
            setDriver={setDriver}
            setDriverSearch={setDriverSearch}
            driverOptions={driverOptions}
            isDriversLoading={isDriversLoading}
            inputValue={inputValue}
            setInputValue={setInputValue}
            isScannerActive={isScannerActive}
            setIsScannerActive={setIsScannerActive}
            isSearchingShipping={false}
            inputRef={inputRef}
            onScan={onScan}
          />

          <div className='flex flex-col gap-8'>
            <ScannedItemsList
              shippings={scannedShippings}
              failedReasons={failedReasons}
              onRemove={handleRemove}
            />

            <ScannerActions
              driver={driver}
              count={scannedShippings.length}
              onReturn={handleReturn}
              disabled={
                scannedShippings.length === 0 || !driver || isProcessing
              }
            />
          </div>
        </div>
      </section>

      {isProcessing && <LoaderBackdrop />}

      <ConfirmDriverModal
        open={!!pendingDriver}
        onClose={cancelDriver}
        onConfirm={handleConfirmDriver}
        driver={pendingDriver}
        scannedCount={scannedShippings.length}
      />
    </section>
  );
};

export default ReturnsIntakeScanner;
